import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmittedHandoversCountSubscriptionVariables = Types.Exact<{
  organization_ids?: Types.InputMaybe<Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input']>;
  customer_status?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  vendor_status?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type SubmittedHandoversCountSubscription = { __typename?: 'subscription_root', handover_aggregate: { __typename?: 'handover_aggregate', aggregate?: { __typename?: 'handover_aggregate_fields', count: number } | null } };


export const SubmittedHandoversCountDocument = gql`
    subscription submittedHandoversCount($organization_ids: [uuid!], $customer_status: [String!], $vendor_status: [String!]) {
  handover_aggregate(
    where: {_or: [{customer_organization_id: {_in: $organization_ids}, status: {_in: $customer_status}}, {vendor_organization_id: {_in: $organization_ids}, status: {_in: $vendor_status}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useSubmittedHandoversCountSubscription__
 *
 * To run a query within a React component, call `useSubmittedHandoversCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubmittedHandoversCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmittedHandoversCountSubscription({
 *   variables: {
 *      organization_ids: // value for 'organization_ids'
 *      customer_status: // value for 'customer_status'
 *      vendor_status: // value for 'vendor_status'
 *   },
 * });
 */
export function useSubmittedHandoversCountSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubmittedHandoversCountSubscription, SubmittedHandoversCountSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubmittedHandoversCountSubscription, SubmittedHandoversCountSubscriptionVariables>(SubmittedHandoversCountDocument, options);
      }
export type SubmittedHandoversCountSubscriptionHookResult = ReturnType<typeof useSubmittedHandoversCountSubscription>;
export type SubmittedHandoversCountSubscriptionResult = Apollo.SubscriptionResult<SubmittedHandoversCountSubscription>;